import React from 'react';
import InternalFamilyInfo from 'Components/ClientApp/CombinedApp/Viewport/Dashboard/FamilyInfo';
import './index.css';

const FamilyInformation = props => <InternalFamilyInfo {...props} />;

export default FamilyInformation;
